interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  highlight?: string;
  desc?: string;
  align?: "center" | "left";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  highlight,
  desc,
  align = "center",
  tone = "light",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const dark = tone === "dark";
  return (
    <div className={`reveal ${isCenter ? "mx-auto text-center" : "text-left"} max-w-2xl`}>
      <span
        className={`inline-flex items-center gap-2 font-label text-sm font-bold uppercase tracking-[0.18em] ${
          dark ? "text-accent-300" : "text-primary-600"
        }`}
      >
        <span className={`h-px w-6 ${dark ? "bg-accent-400" : "bg-primary-400"}`}></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading text-3xl font-black leading-tight tracking-tight md:text-[42px] ${
          dark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
        {highlight && (
          <>
            {" "}
            <span className="text-gradient-anim">{highlight}</span>
          </>
        )}
      </h2>
      {desc && (
        <p
          className={`mt-5 font-body text-base leading-relaxed ${
            dark ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}